(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nixing-product-pdp"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nixing-gallery')) {
    customElements.define(
      'nixing-gallery',
      class extends HTMLElement {
        constructor() {
          super();
          this.handleClick = this.handleClick.bind(this);
        }

        connectedCallback() {
          this.addEventListener('click', this.handleClick);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
        }

        handleClick(event) {
          const button = event.target.closest('.npdp__thumb');
          if (!button || !this.contains(button) || !button.dataset.full) return;
          const main = this.querySelector('.npdp__main-image');
          if (!main) return;

          main.src = button.dataset.full;
          main.removeAttribute('srcset');
          this.querySelectorAll('.npdp__thumb').forEach((item) => {
            item.classList.toggle('is-active', item === button);
            item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
